import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  passwordFormWrapper: {
    marginTop: theme.spacing(24),

    '& h1': {
      textAlign: 'center',
    },

    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(16),
    },
  },
}));
